export function setRuta(ruta){
    return {
        type: 'SET_RUTA',
        payload: ruta
    }
}

export function setProgramacion(data){
    return {
        type: 'SET_PROGRAMACION',
        payload: data
    }
}

export function setLoading(data){
    return {
        type: 'SET_LOADING',
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/actions.js